export default __webpack_public_path__ + "static/media/error.6dff416a.png";